import {
  IsBoolean,
  IsEmail,
  IsEnum,
  IsNotEmpty,
  IsString,
  IsUUID,
} from 'class-validator';
import { CountryCode } from '../enum';
import { Role } from '../enum/role.enum';

export class UserDetailDto {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  login: string;

  @IsEmail()
  @IsNotEmpty()
  email: string;

  @IsString()
  @IsNotEmpty()
  firstName: string;

  @IsString()
  @IsNotEmpty()
  lastName: string;

  @IsBoolean()
  @IsNotEmpty()
  isActive: boolean;

  @IsEnum(CountryCode)
  @IsNotEmpty()
  country: CountryCode;

  @IsEnum(Role)
  @IsNotEmpty()
  role: Role;
}
